import { ItemsSummaryWrapper } from "@components/formGroup";
import BindingContext from "@odata/BindingContext";
import { IDefinition } from "@pages/PageUtils";
import React from "react";

import { IAppContext } from "../../../../contexts/appContext/AppContext.types";
import { FormStorage } from "../../../../views/formView/FormStorage";
import CorrectiveItemsSummary, {
    CorrectiveItemsSummaryPath
} from "../../corrective/extensions/correctiveItemsSummary/CorrectiveItemsSummary";
import ItemsSummary from "./ItemsSummary";

export const ItemsSummaryPath = BindingContext.localContext("ItemsSummary");
export const ItemsSummariesPaths = [ItemsSummaryPath, CorrectiveItemsSummaryPath];

export const addItemsSummaryDef = (definition: IDefinition, context: IAppContext, addCorrectiveItemsSummary?: boolean): void => {
    const itemsGroup = definition.form.groups.find(group => group.id === "Items");

    itemsGroup.lineItems.itemsSummaryRenderer = (args) => {
        return (
            <ItemsSummaryWrapper>
                <ItemsSummary storage={args.storage as FormStorage}/>
                {addCorrectiveItemsSummary && <CorrectiveItemsSummary storage={args.storage as FormStorage}/>}
            </ItemsSummaryWrapper>
        );
    };

    // default value, controlled by variant management
    // by default true, isVatRegisteredCompany behavior handled in ItemsSummary directly
    itemsGroup.lineItems.shouldShowItemsSummary = true;
};